/* eslint-disable max-classes-per-file */
import React from 'react';
import ReactDOM from 'react-dom';
import SearchForm from '../../primary-nav-search-rse/jsx/SearchForm';

/**
 * Primary nav selector
 * @const {string}
 */
const PRIMARY_NAV_SELECTOR = '[data-component="primary-nav"]';

/**
 * Primary nav item selector
 * @const {string}
 */
const NAV_ITEM_SELECTOR = '.primary-nav-item';

/**
 * Primary nav item active
 * @const {string}
 */
export const NAV_ITEM_ACTIVE = 'primary-nav-item--active';

/**
 * Menu expander button control
 * @const {string}
 */
export const MENU_EXPANDER_SELECTOR = '.primary-nav-item__expander';

/**
 * Desktop hamburger selector
 */

const PRIMARY_NAV_DESKTOP_HAMBURGER = '.primary-nav--desktop-burger';

/**
 * Create a new PrimaryNav
 * @param {HTMLElement} PrimaryNav - The HTML element of the primary nav
 * @class
 */
class PrimaryNavImpl {
    constructor(primaryNav) {
        this.primaryNav = primaryNav;

        const menuExpanders = primaryNav.querySelectorAll(
            MENU_EXPANDER_SELECTOR
        );

        menuExpanders.forEach((expander) => {
            const navItem = expander.closest(NAV_ITEM_SELECTOR);
            expander.addEventListener('click', () => {
                this._expandMenu(navItem);
                this._toggleAria(navItem);
            });

            expander.addEventListener('keyup', (event) => {
                const key = event.which || event.keyCode;
                // Call toggle only when escape was pressed.
                // eslint-disable-next-line no-unused-expressions
                key === 27 && this._toggleAria(navItem, key);
            });

            navItem.addEventListener('mouseover', () => {
                this._setMenuOffset(navItem);
            });
        });

        // Add the search REACT app to the page
        const reactAppWrapper = document.querySelector(
            '#react-header-search-root'
        );

        const reactAppLookupUrl =
            reactAppWrapper.getAttribute('data-lookup-url');

        const reactAppWrapperResp = document.querySelector(
            '#react-header-search-root-resp'
        );

        const reactElement = React.createElement(
            SearchForm,
            {
                lookupUrl: reactAppLookupUrl,
            },
            null
        );

        // Add the REACT components to the page
        if (reactAppWrapper !== null) {
            ReactDOM.render(reactElement, reactAppWrapper);
        }
        if (reactAppWrapperResp !== null) {
            ReactDOM.render(reactElement, reactAppWrapperResp);
        }
    }

    isDesktopHamburger() {
        return this.primaryNav.matches(PRIMARY_NAV_DESKTOP_HAMBURGER);
    }

    _toggleAria(primaryNavItem, escapeKey) {
        const buttonExpander = primaryNavItem.querySelector(
            MENU_EXPANDER_SELECTOR
        );
        // If escape was pressed we will set expanded to false.
        const expanded = escapeKey
            ? false
            : buttonExpander.getAttribute('aria-expanded') === 'false';

        buttonExpander.setAttribute('aria-expanded', `${expanded}`);
    }

    _expandMenu(primaryNavItem) {
        // Get all siblings.
        const allItems = document.querySelectorAll(
            `${PRIMARY_NAV_SELECTOR} ${NAV_ITEM_SELECTOR}`
        );
        // Remove active class from all siblings except current one which will be toggled.
        allItems.forEach((item) => {
            // eslint-disable-next-line no-unused-expressions
            item === primaryNavItem
                ? item.classList.toggle(NAV_ITEM_ACTIVE)
                : item.classList.remove(NAV_ITEM_ACTIVE);
        });

        this._setMenuOffset(primaryNavItem);
    }

    _setMenuOffset(primaryNavItem) {
        const navItem = primaryNavItem;

        // Measure if the menu is going to be off screen
        const navBarWidth = navItem.offsetParent.offsetWidth; // Width of the navbar element
        const navItemOffset = navItem.offsetLeft; // How far along the navbar the item selected is
        const menuWidth =
            navItem.querySelector('.mega-menu-wrapper').offsetWidth; // THe width of the mega menu once shown

        const widthDiff = navBarWidth - (navItemOffset + menuWidth);
        if (widthDiff < 0) {
            navItem.dataset.menuOffsetNeeded = 'true';
            navItem.style.setProperty('--menuOffsetNeeded', `${widthDiff}px`);
        }
    }
}

/**
 * Singleton wrapper for Primary Nav to allow control from other areas of the template.
 * @class
 */
export default class PrimaryNav {
    static getInstance() {
        const primaryNav = document.querySelector(PRIMARY_NAV_SELECTOR);
        // primaryNav doesnt exist, return null
        if (!primaryNav) {
            return null;
        }

        // Doesnt exist yet, create new menu object
        if (!primaryNav._primaryNav) {
            // Store the actual class against the DOM, as if this is destroyed for any reason it will need to be re-instantiated
            primaryNav._primaryNav = new PrimaryNavImpl(primaryNav);
        }

        // Return existing primaryNav object
        return primaryNav._primaryNav;
    }
}

// Export for external access and run intial pass
PrimaryNav.getInstance();

// TOGGLE MOBILE MENU AND SEARCH
export const handleRespMenu = () => {
    const matrixBody = document.querySelector('#rse-body');

    // Check only if function is in Matrix
    if (matrixBody) {
        const burger = document.querySelector('#responsive-toggle');
        const mobileCloseText = document.querySelector('.mobile--close');
        const mobileOpenText = document.querySelector('.mobile--open');
        const mobileWrapper = document.querySelector(
            '.primary-nav__resp-wrapper'
        );

        // use Checkbox to Toggle Menu
        const menuCheckbox = document.querySelector('.resp-menu-toggle');
        const mobileNav = document.querySelector('.primary-nav__resp-nav');

        // Responsive Search Elements
        const respNavContent = document.querySelector('#js-resp-nav-content');
        const responsiveSearch = document.querySelector('input[name="search"]');
        const responsiveSearchSuggestions = document.querySelector(
            '.search-suggestions__wrapper'
        );

        const searchIcon = document.querySelector('.svg-icon--search');

        // const searchCancelButton = document.querySelector(
        //     '.desktop-search-cancel'
        // );

        // Toggle state with Checkbox

        menuCheckbox.addEventListener('click', (event) => {
            burger.classList.toggle('menu--open');
            mobileCloseText.classList.toggle('hidden');
            mobileOpenText.classList.toggle('hidden');
            mobileWrapper.classList.toggle('menu--open');
            mobileNav.classList.toggle('menu--open');

            if (responsiveSearchSuggestions) {
                responsiveSearchSuggestions.classList.add('nav--hide');
            }

            // Set Overlay background height equal to window scroll height
            let matrixBodyHeight = parseFloat(matrixBody.scrollHeight);

            window.addEventListener('resize', () => {
                matrixBodyHeight = parseFloat(matrixBody.scrollHeight);
            });

            const overlayBackground =
                document.querySelector('#overlayBackground');

            // Calculate Overlay Height to Scroll Height
            if (event.target.checked) {
                if (window.matchMedia('(max-width: 1280px)')) {
                    overlayBackground.setAttribute(
                        'style',
                        `height: ${matrixBodyHeight - 63}px`
                    );
                }
            } else {
                overlayBackground.setAttribute('style', `height: 0px`);

                if (responsiveSearchSuggestions) {
                    responsiveSearchSuggestions.classList.add('nav--hide');
                }

                const revealRespNav = () => {
                    respNavContent.classList.remove('nav--hide');
                };

                setTimeout(revealRespNav, 500);
            }
        });

        // When typing into checkbox, the menu disappears
        if (responsiveSearch) {
            responsiveSearch.addEventListener('touchstart', () => {
                const scrollTop = () => {
                    document.body.scrollTop = 0;
                };

                setTimeout(scrollTop, 500);

                if (respNavContent) {
                    respNavContent.classList.add('nav--hide');
                }

                if (responsiveSearchSuggestions) {
                    responsiveSearchSuggestions.classList.remove('nav--hide');
                }
            });

            responsiveSearch.addEventListener('click', () => {
                document.body.scrollTop = 0;

                const scrollTop = () => {
                    document.body.scrollTop = 0;
                };

                setTimeout(scrollTop, 500);

                if (respNavContent) {
                    respNavContent.classList.add('nav--hide');
                }

                if (responsiveSearchSuggestions) {
                    responsiveSearchSuggestions.classList.remove('nav--hide');
                }
            });

            searchIcon.addEventListener('click', () => {
                document.body.scrollTop = 0;

                const scrollTop = () => {
                    document.body.scrollTop = 0;
                };

                setTimeout(scrollTop, 500);

                if (respNavContent) {
                    respNavContent.classList.add('nav--hide');
                }

                if (responsiveSearchSuggestions) {
                    responsiveSearchSuggestions.classList.remove('nav--hide');
                }
            });

            // searchCancelButton.addEventListener('click', () => {
            //     document.body.scrollTop = 0;

            //     const scrollTop = () => {
            //         document.body.scrollTop = 0;
            //     };

            //     setTimeout(scrollTop, 500);

            //     if (respNavContent) {
            //         respNavContent.classList.add('nav--hide');
            //     }

            //     if (responsiveSearchSuggestions) {
            //         responsiveSearchSuggestions.classList.remove('nav--hide');
            //     }
            // });
        }
    }
};

if (window.matchMedia('(max-width: 1023px)')) {
    window.addEventListener('DOMContentLoaded', handleRespMenu);
}

// DESKTOP SEARCH
export const handleDesktopSearch = () => {
    const matrixBody = document.querySelector('#rse-body');

    // Check only if function is in Matrix
    if (matrixBody) {
        const desktopSearchToggle = document.querySelector(
            '#js-desktop-search-toggle'
        );

        const desktopSearchToggleOpen = document.querySelector(
            '#js-desktop-search-toggle-open'
        );

        const desktopSearchToggleClose = document.querySelector(
            '#js-desktop-search-toggle-close'
        );

        const desktopSearchWrapper = document.querySelector(
            '#js-desktop-search-wrapper'
        );

        const desktopOverlayBackground = document.querySelector(
            '#js-desktop-search-overlay'
        );

        if (window.matchMedia('(max-width: 1023px)')) {
            desktopSearchWrapper.classList.remove('menu--open');
        }

        window.addEventListener('resize', () => {
            if (window.matchMedia('(max-width: 1023px)')) {
                desktopSearchWrapper.classList.remove('menu--open');
            }
        });

        // Toggle state with button
        desktopSearchToggle.addEventListener('click', () => {
            desktopSearchWrapper.classList.toggle('menu--open');

            if (desktopSearchWrapper.classList.contains('menu--open')) {
                desktopSearchToggle.setAttribute('aria-expanded', true);
                desktopSearchToggleOpen.classList.add('hidden');
                desktopSearchToggleClose.classList.remove('hidden');
            } else {
                desktopSearchToggle.setAttribute('aria-expanded', false);
                desktopSearchToggleOpen.classList.remove('hidden');
                desktopSearchToggleClose.classList.add('hidden');
            }

            // Set Overlay background height equal to window scroll height
            let matrixBodyHeight = parseFloat(matrixBody.scrollHeight);

            window.addEventListener('resize', () => {
                matrixBodyHeight = parseFloat(matrixBody.scrollHeight);
            });

            // Set overlay width

            if (window.matchMedia('(min-width: 1024px)')) {
                desktopOverlayBackground.setAttribute(
                    'style',
                    `height: ${matrixBodyHeight - 127}px`
                );
            } else {
                desktopOverlayBackground.setAttribute('style', `height: 0px`);
            }
        });

        if (desktopOverlayBackground) {
            desktopOverlayBackground.addEventListener('click', (e) => {
                const isOutside = !e.target.closest(
                    '#react-header-search-root'
                );

                if (isOutside) {
                    desktopSearchWrapper.classList.remove('menu--open');
                    desktopSearchToggle.setAttribute('aria-expanded', false);
                    desktopSearchToggleOpen.classList.remove('hidden');
                    desktopSearchToggleClose.classList.add('hidden');
                }
            });
        }

        document.onkeydown = (evt) => {
            if (evt.key === 'Escape') {
                desktopSearchWrapper.classList.remove('menu--open');
                desktopSearchToggle.setAttribute('aria-expanded', false);
                desktopSearchToggleOpen.classList.remove('hidden');
                desktopSearchToggleClose.classList.add('hidden');
            }
        };
    }
};

if (window.matchMedia('(min-width: 1024px)')) {
    window.addEventListener('DOMContentLoaded', handleDesktopSearch);
}

// DESKTOP RESOURCES NAV DROPDOWN
export const revealDesktopDropdownMenu = () => {
    const desktopNavItems = document.querySelectorAll('.js-desktop-items');

    desktopNavItems.forEach((navItem) => {
        navItem.addEventListener('mousedown', (e) => {
            e.preventDefault();
        });
    });
};

if (window.matchMedia('(min-width: 1024px)')) {
    window.addEventListener('DOMContentLoaded', revealDesktopDropdownMenu);
}

export function getNumberOfSavedResources() {
    const savedResources = JSON.parse(window.localStorage.savedResources);
    const numberOfItems = savedResources.length;
    if (numberOfItems > 0) {
        const insertPositions = document.querySelectorAll('.js-saved-number');
        if (insertPositions) {
            for (let i = 0; i < insertPositions.length; i++) {
                insertPositions[i].innerHTML = numberOfItems;
            }
        }

        /* change bookmark colour */
        const empties = document.querySelectorAll(
            '.my-resources-button__bookmark--icon.empty'
        );
        if (empties) {
            empties.forEach((el) => {
                el.classList.add('hide');
            });
        }
        const filled = document.querySelectorAll(
            '.my-resources-button__bookmark--icon.saved'
        );
        if (filled) {
            filled.forEach((el) => {
                el.classList.remove('hide');
            });
        }

        /* hide no-results markup */
        const outputSection = document.getElementById('resources-output');
        if (outputSection) {
            document
                .getElementById('resources-output')
                .classList.remove('no-results');
            document
                .querySelector('.saved-resource_empty')
                .classList.add('hide');
            document
                .querySelector('.saved-resource_wrapper')
                .classList.remove('hide');
        }
    } else {
        const empties = document.querySelectorAll(
            '.my-resources-button__bookmark--icon.empty'
        );
        if (empties) {
            empties.forEach((el) => {
                el.classList.remove('hide');
            });
        }
        const filled = document.querySelectorAll(
            '.my-resources-button__bookmark--icon.saved'
        );
        if (filled) {
            filled.forEach((el) => {
                el.classList.add('hide');
            });
        }

        /* Show no results markup */
        const outputSection = document.getElementById('resources-output');
        if (outputSection) {
            document
                .getElementById('resources-output')
                .classList.add('no-results');
            document
                .querySelector('.saved-resource_empty')
                .classList.remove('hide');
            document
                .querySelector('.saved-resource_wrapper')
                .classList.add('hide');
        }
    }
}

window.addEventListener('DOMContentLoaded', getNumberOfSavedResources);
